import { Component, inject } from '@angular/core';
import { ToastService } from './toast.service';


@Component({
  selector: 'app-toast',
  standalone: true,
  template: `
    @if (toastService.data(); as toast) {
      <div class="fixed bottom-5 right-5 z-100 animate-fade-in-up">
        <div [class]="getClasses(toast.type)" 
             class="relative flex items-center p-4 rounded-xl shadow-2xl border backdrop-blur-sm bg-opacity-95 overflow-hidden">
          
          <div class="shrink-0">
            @switch (toast.type) {
              @case ('success') {
                <svg class="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              }
              @case ('error') {
                <svg class="h-6 w-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              }
            }
          </div>

          <div class="ml-3 mr-8">
            <p class="text-sm font-semibold text-gray-900">{{ toast.message }}</p>
          </div>

          <button (click)="toastService.data.set(null)" class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
            </svg>
          </button>

          <div class="absolute bottom-0 left-0 h-1 bg-current opacity-30 animate-progress"
               [class.text-green-600]="toast.type === 'success'"
               [class.text-red-600]="toast.type === 'error'">
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    .animate-fade-in-up {
      animation: fadeInUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    }

    /* Animación de la barra: de 100% a 0% de ancho */
    .animate-progress {
      animation: progress linear forwards;
      animation-duration: 3000ms; /* Debe coincidir con el tiempo del ToastService */
    }

    @keyframes fadeInUp {
      from { opacity: 0; transform: translateY(1rem) scale(0.95); }
      to { opacity: 1; transform: translateY(0) scale(1); }
    }

    @keyframes progress {
      from { width: 100%; }
      to { width: 0%; }
    }
  `]
})
export class ToastComponent {
  toastService = inject(ToastService);

  getClasses(type: string) {
    const base = 'min-w-[320px] max-w-md ';
    if (type === 'success') return base + 'bg-green-50 border-green-200';
    if (type === 'error') return base + 'bg-red-50 border-red-200';
    return base + 'bg-blue-50 border-blue-200';
  }
}